import React from "react";
import { useTranslation } from "react-i18next";
import IndustryCard from "../../components/Industries/IndustryCard";
import { industries } from "../../data/industries";
import {
  useRevealOnScroll,
  useInViewClass,
} from "../../hooks/useRevealOnScroll";
import SectionIntro from "../../components/SectionIntro/SectionIntro";

const IndustriesSection = () => {
  const { t } = useTranslation();
  const headerRevealRef = useRevealOnScroll();
  const gridInViewRef = useInViewClass("vh-services__grid--visible", {
    threshold: 0.06,
    rootMargin: "0px 0px -4% 0px",
  });

  const n = industries.length;
  const countLabel =
    n === 1
      ? t("industries.focusOne", { count: n })
      : t("industries.focusOther", { count: n });

  return (
    <section
      className="section-n section--industries section--en vh-services"
      aria-labelledby="expertise-heading"
    >
      <div className="container-n">
        <div className="vh-services__layout pr-big">
          <header
            ref={headerRevealRef}
            className="vh-services__header reveal"
          >
            <a className="skip-the-section link-n" href="#contact-us">
              <span className="link-n__text">{t("skip.section")}</span>
            </a>
            <SectionIntro eyebrow={t("industries.eyebrow")}>
              <h2
                id="expertise-heading"
                className="section__title title-h2 vh-section-title vh-services__title"
              >
                {t("industries.titleLine1")} <br />
                {t("industries.titleLine2")}
              </h2>
            </SectionIntro>
            <p className="vh-services__subtitle description-n">
              {t("industries.subtitle")}
            </p>
            <p className="vh-services__meta">{countLabel}</p>
          </header>

          <div
            ref={gridInViewRef}
            className="vh-services__grid"
            role="list"
          >
            {industries.map((service, index) => (
              <div
                key={service.id}
                className="vh-services__cell"
                role="listitem"
                style={{ "--vh-stagger": `${index * 0.072}s` }}
              >
                <IndustryCard industry={service} />
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default IndustriesSection;
